export default __webpack_public_path__ + "static/media/i_wdt_c_2_3.34d22bb5.mp3";